import {
    buyerCostActions,
    buyerCostThunks as defaultThunks,
    buyerCostSelectors as defaultSelectors,
    buyerCostReducer,
} from './BuyerCost-slice';
import * as thunks from './BuyerCost-thunks';
import * as selectors from './BuyerCost-selectors';

const buyerCostThunks = { ...defaultThunks, ...thunks };
const buyerCostSelectors = { ...defaultSelectors, ...selectors };

export { buyerCostSelectors, buyerCostActions, buyerCostThunks, buyerCostReducer };
